import { groupBy } from "lodash";

import { AuthorizationSet, IProfileDto } from "../dto";
import { IProfileListCompanyDto } from "../models";
import { ProfileStorage } from "./browser-storge";
import { Log } from "./log.helpers";
import { getCompanySubDomain } from "./url.helpers";

export const groupByAuthorizedIn = (
  profileDto?: IProfileDto | null,
): Partial<Record<number, AuthorizationSet[]>> | undefined => {
  const { subDomainCompanyId, authorizedIn } = profileDto || {};

  let authorizedInList = authorizedIn || [];

  if (!authorizedInList?.length) {
    return [];
  }

  /* this filtering is applied in all modes, because the domain id is checked on BE to match whole companies list */
  if (subDomainCompanyId) {
    authorizedInList = authorizedInList.filter(
      x => x.companyId === subDomainCompanyId,
    );

    Log.debug(
      `Filter by profile.subDomainCompanyId companies (${authorizedInList?.length}) filtered by companyId ${subDomainCompanyId} `,
    );
  } else {
    const subdomain = getCompanySubDomain();

    /* this filtering is applied only in hybrid mode, to avoid occasional matching of testing domains */
    if (authorizedInList.length && ProfileStorage.isHybridMode && subdomain) {
      Log.info(
        `Allowed companies (${authorizedInList?.length}) filtered by subdomain ${subdomain} `,
      );
      authorizedInList = authorizedInList.filter(
        x => x.companyCode === subdomain,
      );
    }
  }

  if (!authorizedInList?.length) {
    return [];
  }

  return groupBy(authorizedInList, item => item.companyId);
};

export const sortProfileCompanies = (
  dtos: IProfileListCompanyDto[],
): IProfileListCompanyDto[] => {
  return dtos.sort((a, b) => {
    const titleA = a.title?.trim() || "";
    const titleB = b.title?.trim() || "";
    return titleA.localeCompare(titleB);
  });
};
